import ModalClose from '@mui/icons-material/CloseRounded';
import MenuIcon from '@mui/icons-material/Menu';
import Box from '@mui/material/Box';
import DialogTitle from '@mui/material/DialogTitle';
import Drawer from '@mui/material/Drawer';
import Grid from '@mui/material/Grid';
import IconButton from '@mui/material/IconButton';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';
import { FilterMatchMode } from 'primereact/api';
import { Button } from 'primereact/button';
import { Column } from 'primereact/column';
import { DataTable } from 'primereact/datatable';
import { Dialog } from 'primereact/dialog';
import { Dropdown } from 'primereact/dropdown';
import { Image } from 'primereact/image';
import { InputText } from 'primereact/inputtext';
import { MultiSelect } from 'primereact/multiselect';
import { Tag } from 'primereact/tag';
import { Toast } from 'primereact/toast';
import React, { useEffect, useRef, useState } from 'react';
import { settingUsersColumns } from '../../../assets/const/Constant';
import { roles } from '../../../assets/const/userRole';
import getRequest, { putRequest, useApi } from '../../../assets/helper/ApiHandler';
import EditIcon from '../../../assets/images/icons/edit.svg';
import Filter from '../../filter/Filter';
import PopupContent from '../PopupContent';
import { useNavigate } from 'react-router-dom';
import PaginatorTemplate from '../../PanginatorTemplate';
import { useSelector } from 'react-redux';


export default function Users() {
    const toast = useRef(null);
    const filterControlOverlay = useRef(null);
    const [state, setState] = React.useState({ right: false, });
    const [userData, setUserData] = useState([]);
    const [selectedProducts, setSelectedProducts] = useState(null);
    const [rowClick, setRowClick] = useState(false);
    const [globalFilterValue, setGlobalFilterValue] = useState('');
    const [filters, setFilters] = useState({ global: { value: null, matchMode: FilterMatchMode.CONTAINS } });
    const [editedUser, setEditedUser] = useState(null);
    const [editMode, setEditMode] = useState(true);
    const [isUserPopupShown, setIsUserPopupShown] = useState(false);
    const navigate = useNavigate();
    const [rows, setRows] = useState(10);
    const [currentPage, setCurrentPage] = useState(0);
    const totalRecords = useSelector(state => state.totalRecords.count);
    const { getUseRequest } = useApi();
    const [isLoading, setIsloading] = useState([]);


    useEffect(() => {
        getUser();
    }, [rows, currentPage]);

    const toggleDrawer = (anchor, open) => (event) => {
        if (event.type === 'keydown' && (event.key === 'Tab' || event.key === 'Shift')) { return; }
        setState({ ...state, [anchor]: open });
    };

    const userRoleName = (userData) => {
        const roles = userData.authorities || [];
        const roleName = roles.map(role => {
            if (role.startsWith('ROLE_INTERMEDIARY_')) {
                return role.replace('ROLE_INTERMEDIARY_', '');
            } else if (role.startsWith('ROLE_')) {
                return role.replace('ROLE_', '');
            }
            return role;
        }).join(', ');
        return roleName;
    }


    const getUser = async () => {
        setIsloading(true)
        try {
            const users = await getUseRequest(`/admin/users?page=${currentPage}&size=${rows}&sort=id,desc`, null, navigate);
            const modifiedUsers = users.map(user => ({
                ...user,
                fullName: setfullNameOfUser(user),
                status: user.activated ? 'active' : 'stopped',
                role: userRoleName(user)
            }));
            setUserData(modifiedUsers);

        } catch (error) {
            if(toast.current){
                toast.current.show({ severity: "error", summary: 'Error', detail: error.message || error });
            }
        } finally {
            setIsloading(false)
        }
    }

    const setfullNameOfUser = (user) => {
        let first = user.firstName ? user.firstName : '';
        let last = user.lastName ? ' ' + user.lastName : '';
        return first + last;
    }

    const handleFormSubmit = async () => {
        try {
            const updatedUser = {
                ...editedUser,
                activated: editedUser.status === 'active'
            };

            let res = await putRequest(`/admin/users`, updatedUser);
                if(toast.current){
                    toast.current.show({ severity: "success", summary: 'Success', detail: "User updated!" });
                }
                getUser();
                setIsUserPopupShown(false);
        } catch (error) {
            if(toast.current){
                toast.current.show({ severity: "error", summary: 'Error', detail: error.message || error });
            }
        }
    };

    const handleEditClick = (user) => {
        setEditedUser(user);
        setIsUserPopupShown(true);
        setEditMode(true);
    };

    const handleAddNewUser = () => {
        setEditedUser(null);
        setIsUserPopupShown(true);
        setEditMode(false);
    };

    const handleRoleChange = (e) => {
        setEditedUser({ ...editedUser, authorities: e.value });
    };

    const handelStatusChange = (e) => {
        let activatedValue = false;
        if (e.value === 'active') {
            activatedValue = true;
        }
        setEditedUser((prevUser) => ({ ...prevUser, activated: activatedValue, status: e.value }));
    };


    const paginatorTemplate = {
        layout: 'RowsPerPageDropdown CurrentPageReport NextPageLink PrevPageLink',
        RowsPerPageDropdown: (options) => {
            const dropdownOptions = [
                { label: 5, value: 5 },
                { label: 10, value: 10 },
                { label: 20, value: 20 },
                { label: 120, value: 120 }
            ];

            return (
                <React.Fragment>
                    <div className='paginatorLeft'>
                        <span className="mx-1" style={{ color: 'var(--text-color)', userSelect: 'none' }}>
                            Rows per page {' '}
                        </span>
                        <Dropdown value={options.value} options={dropdownOptions} onChange={options.onChange} />
                    </div>
                </React.Fragment>
            );
        },
        CurrentPageReport: (options) => {
            return (
                <div className='paginatorRight'>
                    <span style={{ color: 'var(--text-color)', userSelect: 'none', width: '120px', textAlign: 'center' }}>
                        Pages {options.first} of {options.totalRecords}
                    </span>
                </div>
            );
        }
    };


    const onGlobalFilterChange = (e) => {
        const value = e.target.value;
        let _filters = { ...filters };
        _filters['global'].value = value;
        setFilters(_filters);
        setGlobalFilterValue(value);
    };

    const userFullName = (userData) => {
        return (
            <div>
                {/* {['right'].map((anchor) => (
                    <div className="userFullName flex justify-content-left" key={anchor}>
                        {userData.fullName}
                    </div>
                ))} */}
                <b>{userData.fullName}</b>
            </div>
        )
    }

    const setFilterByCriteria = (filters) => {
        setFilters(filters);
    }

    const renderHeader = () => {
        return (
            <div className="flex justify-content-end" style={{ display: 'flex', justifyContent: 'end' }}>
                <span className="p-input-icon-left">
                    <i className="pi pi-search" />
                    <InputText value={globalFilterValue} onChange={onGlobalFilterChange} placeholder="Search" />
                </span>
                <span className="p-input-icon-left">
                    <Filter
                        columnsList={settingUsersColumns}
                        setFilterByCriteria={setFilterByCriteria}
                    />
                </span>
            </div>
        );
    };


    const [statuses] = useState(['Active', 'Disabled']);
    const [checked, setChecked] = useState(true);


    const getSeverity = (status) => {
        if (status)
            return 'success';
        else
            return 'danger';
    };


    const statusBodyTemplate = (rowData) => {
        return <Tag value={rowData.activated ? "Active" : "Stopped"} severity={getSeverity(rowData.activated)} className={rowData.activated ? 'status status-active' : 'status status-stopped'} />;
    };

    const actionBtn = (rowData) => {
        return (
            <div className="actionBtn flex justify-content-center">
                <Button link onClick={() => handleEditClick(rowData)} tooltip="Edit" tooltipOptions={{ position: 'top', mouseTrack: true, mouseTrackTop: 15 }}><Image src={EditIcon} alt="Edit" width="25" /></Button>
            </div>
        );
    };

    const handleOnRowsChange = (newRows) => {
        setRows(newRows.value);
        setCurrentPage(0);
    };

    const handleOnPageChange = (page) => {
        setCurrentPage(page);
    }


    const onStatusChange = (checked, rowData) => {
        let sts = checked ? "Active" : "Disabled";
        const updatedUserData = userData.map((user) => {
            if (user.email === rowData.email)
                return { ...user, status: sts }
            else
                return user
        });
        console.log(JSON.stringify(updatedUserData));
        setUserData(updatedUserData);
    };


    const headerAddNewUser = (
        <div className="inline-flex align-items-center justify-content-center gap-2">
            <span className="fs-1 white-space-nowrap">
                {editMode ? "Edit User" : "Invite User"}
            </span>
        </div>
    );

    const footerAddNewUser = (
        <div>
            <Button label="Cancel" className='button-style-2' onClick={() => setIsUserPopupShown(false)} autoFocus />
            <Button
                label={editMode ? "Update User" : "Invite User"}
                className='button-style-1'
                onClick={(e) => {
                    if (editMode) {
                        handleFormSubmit(); // Call handleFormSubmit when in edit mode
                    } else {
                        newUserInviteSent(e, toastNewUserInviteSent, 'success');
                        setIsUserPopupShown(false);
                    }
                }}
                autoFocus
            />
        </div>
    );


    const toastNewUserInviteSent = useRef(null);
    const newUserInviteSent = (event, ref, severity) => {
        ref.current.show({ severity: 'contrast', summary: 'Invite Sent', detail: 'Invite was successfully sent to email.', life: 3000 });
    };

    const selectedRoles = (editedUser) => {
        let userSelectedRoles = [];
        editedUser?.authorities.map(role => {
            let userRole = roles.filter(item => {
                return item.value === role;
            })
            userSelectedRoles.push(userRole[0]);
        })
        console.log(userSelectedRoles);
    }
    return (
        <div>
            <Toast ref={toast} position="bottom-right"></Toast>
            <Toolbar className='main-content-header'>
                <Typography variant="h6" noWrap component="div">
                    <h2 className='fs-16-600'>Manage Users</h2>
                </Typography>
                <Button type="button" icon="pi pi-plus" className="button-style-1" label="Add user" size="small" onClick={handleAddNewUser} autoFocus />
                <IconButton
                    color="inherit"
                    aria-label="open drawer"
                    edge="start"
                    sx={{ mr: 2, display: { sm: 'none' } }}>
                    <MenuIcon />
                </IconButton>
            </Toolbar>

            <DataTable
                value={userData}
                filters={filters}
                loading={isLoading}
                header={renderHeader()}
                emptyMessage="No users found."
                selectionMode={rowClick ? null : 'checkbox'}
                scrollable
                scrollHeight="400px"
                selection={selectedProducts}
                onSelectionChange={(e) => setSelectedProducts(e.value)}
                dataKey="id"
                className="userData-setting"
                paginator rows={10}
                paginatorTemplate={
                    PaginatorTemplate({
                        currentPage,
                        totalRecords,
                        rows,
                        handleOnRowsChange,
                        handleOnPageChange,
                    })}
                tableStyle={{ minWidth: '50rem' }}
                resizableColumns
            >
                <Column field="fullName" header="Full Name" body={userFullName} filterPlaceholder="Search by name" bodyStyle={{ textAlign: 'left' }}></Column>
                <Column field="email" header="Email" headerStyle={{ textAlign: 'left' }} alignHeader={'left'} bodyStyle={{ textAlign: 'left' }}></Column>
                <Column field="role" header="Role" headerStyle={{ terolesxtAlign: 'left' }} alignHeader={'left'} bodyStyle={{ textAlign: 'left' }}></Column>
                <Column field="designation" header="Designation" headerStyle={{ textAlign: 'left' }} alignHeader={'left'} bodyStyle={{ textAlign: 'left' }}></Column>
                <Column field="activated" header="Status" style={{ minWidth: '12rem' }} body={statusBodyTemplate} headerStyle={{ textAlign: 'center' }} alignHeader={'center'} bodyStyle={{ textAlign: 'center' }}></Column>
                <Column field="action" body={actionBtn} header="Action" headerStyle={{ textAlign: 'center' }} alignHeader={'center'} bodyStyle={{ textAlign: 'center' }}></Column>

            </DataTable>

            {['right'].map((anchor) => (
                <Drawer key={anchor}
                    anchor={anchor}
                    open={state[anchor]}
                    onClose={toggleDrawer(anchor, false)}>
                    <Box className='drawerHeader'>
                        <DialogTitle >PLX</DialogTitle>
                        <ModalClose className='drawerClose' onClick={toggleDrawer(anchor, false)} />
                    </Box>
                    <PopupContent />
                </Drawer>
            ))}

            <Dialog className='invite-user-dialog' visible={isUserPopupShown} modal header={headerAddNewUser} footer={footerAddNewUser} style={{ width: '330px' }} onHide={() => setIsUserPopupShown(false)}>
                <Box className="omega-forms" >
                    <Box sx={{ minWidth: 0, flex: 1, padding: '1rem' }}>
                        <Grid container spacing={2}>
                            <Grid item xs={12}>
                                <Typography level="title-sm" className='fs-2'>Name</Typography>
                                <InputText id="name" value={editedUser?.firstName || ''} placeholder="" className="mr-2" onChange={(e) => setEditedUser({ ...editedUser, firstName: e.target.value })} />
                            </Grid>
                            <Grid item xs={12}>
                                <Typography level="title-sm" className='fs-2'>Email</Typography>
                                <InputText id="email" value={editedUser?.email || ''} placeholder="" className="mr-2" onChange={(e) => setEditedUser({ ...editedUser, email: e.target.value })} />
                            </Grid>
                            <Grid item xs={12}>
                                <Typography level="title-sm" className='fs-2'>Role</Typography>
                                <MultiSelect
                                    display='chip'
                                    filter
                                    id="authorities"
                                    value={editedUser?.authorities || []}
                                    options={roles}
                                    onChange={handleRoleChange}
                                    className="mr-2"
                                    optionLabel="label"
                                />
                            </Grid>

                            {editMode && (
                                <Grid item xs={12}>
                                    <Typography level="title-sm" className='fs-2'>Status</Typography>
                                    <Dropdown
                                        id='activated'
                                        className="mr-2"
                                        value={editedUser?.status || null}
                                        options={[
                                            { label: 'Active', value: 'active' },
                                            { label: 'Stopped', value: 'stopped' },
                                            { label: 'Archive', value: 'archive' },
                                        ]}
                                        onChange={handelStatusChange}
                                    />

                                </Grid>
                            )}
                        </Grid>

                    </Box>
                </Box>
            </Dialog>
            <Toast ref={toastNewUserInviteSent} position="bottom-right" />
        </div>
    )
}
